import { render, staticRenderFns } from "./CancelSubscription.vue?vue&type=template&id=65aa0f38&"
import script from "./CancelSubscription.vue?vue&type=script&lang=js&"
export * from "./CancelSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCardText})
